import React, { Fragment } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';

import saveAs from 'file-saver';

import Config from '../../constants/appConfig';
import MaterialIcon from './../../components/MaterialIcon';
import TextField from '@material-ui/core/TextField';
import SearchIcon from "@material-ui/icons/Search";

import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import AccountCircle from '@material-ui/icons/AccountCircle';
import Icon from '@material-ui/core/Icon';
import MenuIcon from '@material-ui/icons/Menu';

import { notification } from 'antd';

import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import SvgIcon from '@material-ui/core/SvgIcon';

import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import color from '@material-ui/core/colors/amber';

//import { withTranslation } from "react-i18next";

function getSorting(order, orderBy) {
  return order === 'desc'
    ? (a, b) => (b[orderBy] < a[orderBy] ? -1 : 1)
    : (a, b) => (a[orderBy] < b[orderBy] ? -1 : 1);
}

class EnhancedTableHead extends React.Component {
  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const { order, orderBy, res } = this.props;

    const columnData = [
      { sort: 'progress', id: 'action', disablePadding: false, label: '', align: 'center', width: true },
      { sort: 'title', id: 'title', disablePadding: false, label: res.TITULO, align: 'left', width: false },
      { sort: 'progress', id: 'progress', disablePadding: false, label: '%', align: 'left', width: true },
      { sort: 'downloadKmz', id: 'downloadKmz', disablePadding: false, label: res.DOWNLOAD_KMZ, align: 'left', width: true },
      { sort: 'downloadJson', id: 'downloadJson', disablePadding: false, label: res.DOWNLOAD_JSON, align: 'left', width: true }
    ];

    return (
      <TableHead>
        <TableRow>
          {columnData.map(column => {
            return (
              <TableCell
                key={column.id}
                padding={column.disablePadding ? 'none' : 'default'}
                sortDirection={orderBy === column.id ? order : false}
                align={column.align}
                style={column.width ? { width: '4rem' } : {}}
              >
                <Tooltip
                  title="Sort"
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === column.id}
                    direction={order}
                    onClick={this.createSortHandler(column.sort)}
                  >
                    {column.label}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const toolbarStyles = theme => ({
  root: {
    paddingRight: theme.spacing(),
  },
  highlight: {
    color: '#6c76ff',
    backgroundColor: '#d7d9e0',
  },
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 0 auto',
  },
});

let EnhancedTableToolbar = props => {
  const { classes, handleChange, filtro, clear, res } = props;

  const limpaCampo = () => {
    document.getElementById('campoFiltro').value = '';
    clear();
  }

  return (
    <Toolbar
      className={classNames(classes.root)}
    >
      <div className={classes.title}>
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        <div style={{ width: '14rem' }}>
          <SearchIcon style={{ marginRight: '.5rem', marginTop: '1.5rem' }} />
          <TextField
            placeholder={res.FILTRO}
            margin="normal"
            onChange={handleChange('filtro')}
            id="campoFiltro"
            type="search"
          />
          {(filtro === '') ? <div></div> :

            <MaterialIcon icon="clear" style={{ position: 'absolute', top: '1.7rem', right: '0.7rem', cursor: 'pointer' }} onClick={() => limpaCampo()} />

          }
        </div>
      </div>
    </Toolbar >
  );
};

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
};

EnhancedTableToolbar = withStyles(toolbarStyles)(EnhancedTableToolbar);

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(3),
  },
  table: {
    minWidth: 600,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
});

class EnhancedTable extends React.Component {

  state = {
    order: 'asc',
    orderBy: 'usuarios',
    selected: [],
    data: [],
    page: 0,
    rowsPerPage: 9,
    error: null,
    filtro: '',
    open: false,
    validade: new Date(0),
    checkVazao: true,
    checkVolume: true,
    checkOnOff: true,
    checkRumo: true,
    checkAltura: true,
    checkCliente: true,
    checkAeronave: true,
    checkClima: true,
    checkTrajetoria: true,
    checkPoligono: true,
    checkPoligonoLimpo: false,
    checkXcl: true,
    checkVelocidade: true,
    checkFaixa: true,
    filePathJob: '',
    disabledPorcessJob: true
  };

  date = new Date();

  componentDidMount() {
    this.updateList();
    this.updateAccess();
    this.date.setDate(this.date.getDate() + 30);
  }

  componentWillUnmount() {
    // fix Warning: Can't perform a React state update on an unmounted component
    this.setState = (state, callback) => {
      return;
    };
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  clear = () => {
    this.setState({
      filtro: ''
    });
  };

  updateList = () => {
    const apiUrl = Config.server + '/task/datajob'

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    }

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          this.setState({
            data: result
          });
          if (result && result.length > 0) {
            setTimeout(() => this.updateList(), 3000);
          }
        },
        (error) => {
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            console.log(error);
            this.props.link('/login');
          }
          else {
            console.log(error);
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  };

  updateAccess = () => {
    const apiUrl = Config.server + '/get_access'

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    }

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          if (result.length > 0) {
            if (result[0].created !== null) {
              let d = new Date(result[0].created);
              d.setDate(d.getDate() + 90);
              this.setState({
                validade: d
              });
            }
          }
        },
        (error) => {
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            console.log(error);
            this.props.link('/login');
          }
          else {
            console.log(error);
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  };

  gerarToken = () => {
    let apiUrl = Config.server + '/access';
    let method = 'POST';

    const formData = new URLSearchParams();

    let options = {
      method: method,
      body: formData,
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    }

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          this.setState({ open: !this.state.open });
          this.updateAccess();
        },
        (error) => {
          if (error.status === 400) {
            this.setState({ open: !this.state.open });
          } else if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            console.log(error);
            this.props.link('/login');
          } else {
            console.log(error);
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  }

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({ order, orderBy });
  };

  handleSelectAllClick = (event, checked) => {
    if (checked) {
      this.setState(state => ({ selected: state.data.map(n => n.id) }));
      return;
    }
    this.setState({ selected: [] });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
  };

  isSelected = id => this.state.selected.indexOf(id) !== -1;

  //upload de arquivos TXT e zjob
  loadFile = file => {
    let filePath = file.target.files[0];
    let ext = fileName => fileName.split(".").pop();

    document.getElementById('jobSelected').textContent = filePath.name;

    if (ext(filePath.name.toLowerCase()) === 'zjob') {
      this.setState({
        filePathJob: filePath,
        disabledPorcessJob: false
      });
    }
  };

  uploadFile = () => {

    let file = this.state.filePathJob;

    document.getElementById('jobSelected').textContent = '';

    this.setState({
      open: !this.state.open,
      progress: true,
      disabledPorcessJob: true,
      filePathJob: ''

    });

    let apiUrl = Config.server + '/loadFile';
    let method = 'POST';

    let config = [{
      checkVazao: this.state.checkVazao,
      checkVolume: this.state.checkVolume,
      checkOnOff: this.state.checkOnOff,
      checkRumo: this.state.checkRumo,
      checkAltura: this.state.checkAltura,
      checkCliente: this.state.checkCliente,
      checkAeronave: this.state.checkAeronave,
      checkClima: this.state.checkClima,
      checkTrajetoria: this.state.checkTrajetoria,
      checkPoligono: this.state.checkPoligono,
      checkPoligonoLimpo: this.state.checkPoligonoLimpo,
      checkXcl: this.state.checkXcl,
      checkVelocidade: this.state.checkVelocidade,
      checkFaixa: this.state.checkFaixa
    }];

    const formData = new FormData();

    formData.append('file', file, 'teste.file');
    formData.append('config', JSON.stringify(config));

    let options = {
      method: method,
      body: formData,
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    }

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          this.updateList();
          //this.loadTask(false);
        },
        (error) => {
          this.setState({ progress: false });
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            this.props.link('/login');
          } else if (error.status === 400) {
            error.json().then(
              (errCode) => {
                notification.open({
                  message: this.props.res[errCode.code],
                  icon: <MaterialIcon icon="error" className="text-danger" />
                });
              });
          } else {
            console.log(error);
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  }

  downloadJob = (id, tipo = null) => {
    if (id > 0) {

      if (tipo === null || tipo === ".json") {
        let apiUrl = Config.server + '/getJsonFile/' + id;
        let method = 'GET';

        let options = {
          method: method,
          headers: {
            'Authorization': localStorage.getItem('access-token-jwt')
          }
        }

        fetch(apiUrl, options)
          .then((res) => {
            if (res.status !== 200) throw res;
            else return res.blob();
          })
          .then(
            (result) => {
              this.setState({ progress: false });
              let file_name = 'exe' + (Date.now()) + ".json";
              saveAs(result, file_name);
            },
            (error) => {
              this.setState({ progress: false });
              if (error.status === 405) {
                notification.open({
                  message: this.props.res.PERMISSAO,
                  description: this.props.res.PERMISSAO_MSG,
                  icon: <MaterialIcon icon="error" className="text-danger" />
                });
              } else if (error.status === 401 || error.status === 403) {
                console.log(error);
                this.props.link('/login');
              }
              else {
                console.log(error);
                notification.open({
                  message: this.props.res.ERRO,
                  description: this.props.res.ERRO_MSG,
                  icon: <MaterialIcon icon="error" className="text-danger" />
                });
              }
            }
          );
      } else {

        let apiUrl = Config.server + '/get_kmz_file/' + id;
        let method = 'GET';

        let options = {
          method: method,
          headers: {
            'Authorization': localStorage.getItem('access-token-jwt')
          }
        }

        fetch(apiUrl, options)
          .then((res) => {
            if (res.status !== 200) throw res;
            else return res.blob();
          })
          .then(
            (result) => {
              this.setState({ progress: false });
              let file_name = 'down' + (Date.now()) + ".kmz";
              saveAs(result, file_name);
            },
            (error) => {
              this.setState({ progress: false });
              if (error.status === 405) {
                notification.open({
                  message: this.props.res.PERMISSAO,
                  description: this.props.res.PERMISSAO_MSG,
                  icon: <MaterialIcon icon="error" className="text-danger" />
                });
              } else if (error.status === 401 || error.status === 403) {
                console.log(error);
                this.props.link('/login');
              }
              else {
                console.log(error);
                notification.open({
                  message: this.props.res.ERRO,
                  description: this.props.res.ERRO_MSG,
                  icon: <MaterialIcon icon="error" className="text-danger" />
                });
              }
            }
          );
      }
    }
  }

  estiloDonwOn = {
    fontSize: "12px", fontWeight: "bold", marginLeft: "0.15rem"
  }

  estiloDonwOff = {
    fontSize: "12px", fontWeight: "bold", marginLeft: "0.15rem", color: "#bdbdbd"
  }

  openModal = () => {
    this.setState({
      open: !this.state.open,
      checkVazao: true,
      checkVolume: true,
      checkOnOff: true,
      checkRumo: true,
      checkAltura: true,
      checkCliente: true,
      checkAeronave: true,
      checkClima: true,
      checkTrajetoria: true,
      checkPoligono: true,
      checkPoligonoLimpo: false,
      checkXcl: true,
      checkVelocidade: true,
      checkFaixa: true
    });
  }

  render() {
    const { classes, res } = this.props;
    const { data, order, orderBy, selected, rowsPerPage, page } = this.state;
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

    return (
      <div>
        <FormGroup row>
          <Dialog open={this.state.open} onClose={event => this.setState({ open: false })} >
            <DialogTitle id="customized-dialog-title">
              Configurações do relatório
            </DialogTitle>

            <DialogContent>
              <DialogTitle id="customized-dialog-title">
                Mapa
              </DialogTitle>
              <DialogContentText style={{ display: 'grid', gridTemplateColumns: '15rem 15rem' }}>
                <FormControlLabel control={<Switch color="primary" checked={this.state.checkTrajetoria} name="checkTrajetoria" onClick={event => this.setState({ checkTrajetoria: !this.state.checkTrajetoria })} />} label={res.TRAJETORIA_VOO} />
                <FormControlLabel control={<Switch color="primary" checked={this.state.checkPoligono} name="checkPoligono" onClick={event => this.setState({ checkPoligono: !this.state.checkPoligono })} />} label={res.POLIGONO_APLICADO} />
                <FormControlLabel control={<Switch color="primary" checked={this.state.checkPoligonoLimpo} name="checkPoligonoLimpo" onClick={event => this.setState({ checkPoligonoLimpo: !this.state.checkPoligonoLimpo })} />} label={res.POLIGONO_NAO_APLICADO} />
                <FormControlLabel control={<Switch color="primary" checked={this.state.checkXcl} name="checkXcl" onClick={event => this.setState({ checkXcl: !this.state.checkXcl })} />} label={res.ZONA_EXCLUSAO} />
              </DialogContentText>
              <DialogTitle id="customized-dialog-title">
                Trabalho
              </DialogTitle>
              <DialogContentText style={{ display: 'grid', gridTemplateColumns: '15rem 15rem' }}>
                <FormControlLabel control={<Switch color="primary" checked={this.state.checkVazao} name="checkVazao" onClick={event => this.setState({ checkVazao: !this.state.checkVazao })} />} label={res.VAZAO} />
                <FormControlLabel control={<Switch color="primary" checked={this.state.checkVolume} name="checkVolume" onClick={event => this.setState({ checkVolume: !this.state.checkVolume })} />} label={res.VOLUME_APLICADO} />
                <FormControlLabel control={<Switch color="primary" checked={this.state.checkOnOff} name="checkOnOff" onClick={event => this.setState({ checkOnOff: !this.state.checkOnOff })} />} label={res.SPRAY_ON_OFF} />
                <FormControlLabel control={<Switch color="primary" checked={this.state.checkRumo} name="checkRumo" onClick={event => this.setState({ checkRumo: !this.state.checkRumo })} />} label={res.RUMO_AB} />
                <FormControlLabel control={<Switch color="primary" checked={this.state.checkAltura} name="checkAltura" onClick={event => this.setState({ checkAltura: !this.state.checkAltura })} />} label={res.ALTURA} />
                <FormControlLabel control={<Switch color="primary" checked={this.state.checkCliente} name="checkCliente" onClick={event => this.setState({ checkCliente: !this.state.checkCliente })} />} label={res.NOME_CLIENTE} />
                <FormControlLabel control={<Switch color="primary" checked={this.state.checkAeronave} name="checkAeronave" onClick={event => this.setState({ checkAeronave: !this.state.checkAeronave })} />} label={res.PREFIXO_AERONAVE} />
                <FormControlLabel control={<Switch color="primary" checked={this.state.checkClima} name="checkClima" onClick={event => this.setState({ checkClima: !this.state.checkClima })} />} label={res.VARIAVEIS_CLIMA} />
                <FormControlLabel control={<Switch color="primary" checked={this.state.checkVelocidade} name="checkVelocidade" onClick={event => this.setState({ checkVelocidade: !this.state.checkVelocidade })} />} label={res.VELOCIDADE} />
                <FormControlLabel control={<Switch color="primary" checked={this.state.checkFaixa} name="checkFaixa" onClick={event => this.setState({ checkFaixa: !this.state.checkFaixa })} />} label={res.FAIXA_APLICACAO} />
              </DialogContentText>
            </DialogContent>
            <DialogActions style={{ display: 'flex', justifyContent: 'space-evenly' }}>
              <input
                accept=".zjob"
                style={{ display: 'none' }}
                id="selectJob"
                type="file"
                onChange={this.loadFile}
              />
              <label htmlFor="selectJob">
                <div style={{ display: 'flex', alignItems: 'baseline' }}>
                  <span><Icon>attach_file</Icon></span>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span id='jobSelected' style={{ borderBottom: '1px #757575 solid' }}></span>
                    <span style={{ color: '#757575' }}>Selecione um arquivo .zjob</span>
                  </div>
                </div>
              </label>
              <Button disabled={this.state.disabledPorcessJob} id='prcessJob' component="span" variant="contained" color="primary" style={{ marginRight: '.4rem' }} className="popUpButton" title={res.PROCESSAR_JOB} onClick={this.uploadFile}>
                <SvgIcon viewBox="-1 -1 12 12" className="iconArrow"
                  style={{ color: 'white', transform: 'rotate(180deg)', width: '2rem', height: '2rem' }}>
                  <path class="fil0" d="M4.52 2c0.42,0.93 -0.05,0.51 0.88,0.83 0.41,0.14 0.31,0.32 0.77,0.04 0.14,-0.09 0.18,-0.15 0.33,-0.18l0.45 0.48c-0.09,0.23 -0.4,0.45 -0.41,0.61 -0.01,0.19 0.08,0.28 0.12,0.44 0.04,0.17 0.03,0.3 0.06,0.48 0.04,0.22 0.07,0.23 0.24,0.32 0.08,0.04 0.17,0.07 0.22,0.1 0.04,0.02 0.2,0.03 0.16,0.29l-0.2 0.49c-0.95,-0.08 -0.41,-0.3 -1.09,0.31 -0.68,0.6 -0.41,0.07 -0.44,1.05 -0.11,0.05 -0.15,0.07 -0.3,0.11l-0.24 0.03c-0.23,-0.01 -0.21,-0.15 -0.29,-0.38 -0.15,-0.41 -0.31,-0.27 -0.74,-0.42 -0.41,-0.14 -0.31,-0.32 -0.77,-0.04 -0.14,0.09 -0.18,0.15 -0.33,0.18l-0.45 -0.48c0.09,-0.23 0.4,-0.45 0.41,-0.61 0.01,-0.19 -0.08,-0.28 -0.12,-0.44 -0.11,-0.43 0.06,-0.6 -0.31,-0.8 -0.16,-0.09 -0.27,-0.13 -0.42,-0.22 0.04,-0.24 0.15,-0.49 0.25,-0.66 0.95,0.08 0.41,0.3 1.09,-0.31 0.4,-0.36 0.44,-0.15 0.47,-0.58 0.01,-0.29 -0.28,-0.61 0.66,-0.64zm-2.98 2.01c-0.02,0.42 0.03,0.55 0.45,0.78 0.23,0.12 0.15,0.02 0.21,0.3 0.22,1.07 -0.16,0.25 -0.22,1.23 -0.02,0.27 0.55,0.91 0.83,0.93 0.95,0.06 0.2,-0.38 1.16,-0.1 0.23,0.06 0.25,0.03 0.35,0.22 0.08,0.14 0.08,0.27 0.18,0.38 0.32,0.36 1.26,0.19 1.5,-0.15 0.13,-0.19 0.11,-0.28 0.14,-0.57 0.03,-0.29 0.42,-0.64 0.71,-0.64 0.27,0.01 0.4,0.06 0.59,-0.05 0.32,-0.19 0.44,-0.72 0.46,-1.07 0.02,-0.34 -0.21,-0.5 -0.45,-0.63 -0.21,-0.11 -0.17,-0.04 -0.22,-0.3 -0.02,-0.14 -0.08,-0.36 -0.07,-0.47 0.01,-0.26 0.26,-0.07 0.3,-0.76 0.02,-0.26 -0.18,-0.4 -0.32,-0.55 -0.3,-0.35 -0.24,-0.36 -0.71,-0.39 -0.56,-0.03 -0.07,0.38 -0.96,0.11 -0.56,-0.16 -0.26,-0.29 -0.53,-0.6 -0.33,-0.38 -1.29,-0.16 -1.51,0.15 -0.13,0.17 -0.1,0.31 -0.13,0.57 -0.03,0.28 -0.1,0.26 -0.27,0.41 -0.18,0.16 -0.16,0.23 -0.44,0.23 -0.28,-0.01 -0.65,-0.15 -0.89,0.43 -0.06,0.15 -0.15,0.38 -0.16,0.54z" />
                  <path class="fil0" d="M0.81 0.64c-0.17,0.56 0.05,0.47 0.75,0.51 -0.27,0.35 -0.32,0.33 -0.52,0.59 -0.19,0.25 -0.29,0.39 -0.46,0.69 -0.89,1.54 -0.74,3.79 0.35,5.11 0.51,0.61 0.74,0.87 1.5,1.31 0.39,0.23 2.25,0.91 2.28,0.38 0.05,-0.77 -0.85,0.27 -3,-1.6 -0.51,-0.45 -0.96,-1.44 -1.1,-2.15 -0.25,-1.18 0.09,-2.38 0.8,-3.33 0.11,-0.14 0.41,-0.48 0.53,-0.56 -0.03,0.56 -0.13,0.83 0.27,0.85 0.37,0.02 0.3,-0.82 0.33,-1.28 0.04,-0.62 -0.24,-0.48 -1.47,-0.55 -0.08,-0.01 -0.2,0.01 -0.26,0.03z" />
                  <path class="fil0" d="M4.73 0.2c-0.04,0.66 0.7,-0.02 2.37,1.08 0.65,0.42 1.15,1.09 1.45,1.79 0.62,1.44 0.39,3.14 -0.65,4.35 -0.08,0.1 -0.33,0.36 -0.41,0.42 0.04,-0.57 0.14,-0.83 -0.26,-0.85 -0.38,-0.02 -0.31,0.88 -0.34,1.38 -0.03,0.52 0.49,0.39 1.53,0.46 0.11,0 0.27,-0.14 0.27,-0.2 0.03,-0.44 -0.36,-0.33 -0.81,-0.36 0.13,-0.37 1.41,-0.93 1.55,-3.43 0.07,-1.19 -0.38,-2.32 -1.11,-3.18 -0.01,-0.01 -0.02,-0.02 -0.02,-0.03 -0.38,-0.41 -0.75,-0.75 -1.26,-1.04 -0.36,-0.2 -2.28,-0.94 -2.31,-0.39z" />
                  <path class="fil0" d="M4 4.67c0.05,-0.93 1.5,-0.93 1.44,0.14 -0.05,0.83 -1.5,0.88 -1.44,-0.14zm-0.57 -0.03c-0.08,1.31 1.76,1.89 2.4,0.71 0.6,-1.13 -0.51,-2.22 -1.54,-1.84 -0.46,0.17 -0.84,0.64 -0.86,1.13z" />
                </SvgIcon>
              </Button>
              <Button
                variant="contained"
                onClick={event => this.setState({ open: !this.state.open })}
              >
                {res.CANCELAR}
              </Button>
            </DialogActions>
          </Dialog>
        </FormGroup>

        <div className="divContent">
          <div className="containerTitle">
            <div>
              <Typography variant="h4" id="tableTitle">
                {res.RELATORIO}
              </Typography>
            </div>
            <div className="centerTop"></div>
            <div>
              <Button variant="contained" color="primary" style={{ marginRight: '.4rem' }} className="popUpButton" onClick={this.openModal} title={res.NOVO_ORCAMENTO}>
                <SvgIcon viewBox="0 0 1000 1000" className="iconArrow"
                  style={{ color: 'white', transform: 'rotate(180deg)', width: '2rem', height: '2rem' }}>
                  <path id="polygon" d="M122.513 646.499c3.66376,13.0115 11.813,21.1608 24.4821,24.3451l273.344 0 36.1582 0.47937 25.5093 0 -0.513611 13.662 0 107.002c4.17737,9.51892 9.69012,14.8605 16.504,16.1959 6.84814,1.16418 14.5181,3.97192 23.0098,8.14929 8.14929,-4.17737 15.4768,-6.98511 22.1537,-8.14929 6.67694,-1.33539 12.3267,-6.84814 16.8464,-16.6752l0 -106.523 0 -13.662 25.5093 0 35.6446 -0.47937 273.344 0c12.3267,-3.18439 20.5102,-11.3337 24.4821,-24.3451l-0.47937 -88.8204 -365.828 0 -6.84814 -69.3374 0.992981 10.1695 3.01318 -106.009 16.1616 0 4.34857 145.66 4.31433 -145.66 16.1616 0 4.34857 145.66 4.00616 -145.66 15.9904 0 4.48553 145.66 4.34857 -145.66 10.3407 0c0.992981,-0.513611 1.81476,-0.992981 2.67078,-1.33539 0.821777,-0.342407 1.64355,-0.650574 2.63653,-0.992981l4.34857 147.988 4.48553 -156.822c0.684814,-0.992981 1.19842,-2.67078 1.849,-5.34155l-1.33539 -6.33453 3.83496 -143.16 -18.0106 0 2.84198 102.174 -0.513611 -1.50659 -11.6418 0 3.32135 -100.668 -18.49 0 2.97894 100.668 -12.3267 0 3.01318 -100.668 -18.0106 0 2.84198 100.668 -12.1555 0 2.97894 -100.668 -18.1476 0 2.49957 100.668 -12.1897 0 2.84198 -100.668 -18.0106 0 2.84198 100.668 -1.81476 0c-4.00616,-1.67779 -7.36175,-4.17737 -10.3407,-7.32751l2.97894 -93.3402 -18.1476 0 2.49957 92.8266c-3.01318,3.32135 -6.50574,5.82092 -10.8543,7.84112l-0.821777 0 2.32837 -100.668 -17.9764 0 2.80774 100.668 -12.1555 0 3.01318 -100.668 -18.1818 0 3.01318 100.668 -12.6691 0 2.80774 -100.668 -17.9764 0 2.97894 100.668 -12.3267 0 3.01318 -100.668 -18.1818 0 3.01318 100.668 -12.1555 0 -2.49957 8.8341 1.98596 -7.32751 2.84198 -102.174 -18.0106 0 4.34857 143.16 -1.849 6.33453c-0.342407,-1.33539 0.342407,0.513611 1.849,5.34155l4.99914 156.822 4.31433 -147.988c0,0 1.67779,0.821777 4.82794,2.32837l10.8543 0 4.31433 145.66 4.51977 -145.66 15.9904 0 4.48553 145.66 3.83496 -145.66 16.6752 0 3.83496 145.66 4.34857 -145.66 16.1616 0 2.97894 100.668 -6.33453 64.5095 -365.828 0 -0.47937 88.8204zm19.6542 -419.997l9.17651 311.659 8.8341 -311.659 -18.0106 0zm24.8245 0l8.8341 311.659 9.17651 -311.659 -18.0106 0zm24.3451 0l9.31347 311.659 8.8341 -311.659 -18.1476 0zm24.9957 0l8.8341 311.659 9.17651 -311.659 -18.0106 0zm24.3451 0l9.31347 311.659 8.8341 -311.659 -18.1476 0zm24.9957 0l8.8341 311.659 9.14227 -311.659 -17.9764 0zm24.3109 0l9.34771 311.659 8.8341 -311.659 -18.1818 0zm24.5163 0l9.17651 311.659 9.31347 -311.659 -18.49 0zm24.8245 0l8.8341 311.659 9.34771 -311.659 -18.1818 0zm24.5163 0l9.14227 311.659 9.34771 -311.659 -18.49 0zm135.148 228.488l1.50659 -62.4893 4.34857 0 -5.85516 62.4893zm37.6648 -62.4893l4.86218 0 1.98596 72.3164 -6.84814 -72.3164zm110.837 -9.65588c0,-0.342407 0.171204,-0.513611 0.513611,-0.513611l-0.513611 0.513611zm12.1897 -156.343l9.31347 311.659 8.6629 -311.659 -17.9764 0zm24.8245 0l8.8341 311.659 9.31347 -311.659 -18.1476 0zm24.4821 0l9.34771 311.659 9.17651 -311.659 -18.5242 0zm24.8588 0l9.31347 311.659 8.8341 -311.659 -18.1476 0zm24.4821 0l9.17651 311.659 9.31347 -311.659 -18.49 0zm24.8245 0l9.34771 311.659 8.8341 -311.659 -18.1818 0zm24.0027 0l9.17651 311.659 8.8341 -311.659 -18.0106 0zm24.8588 0l9.31347 311.659 8.8341 -311.659 -18.1476 0zm24.4821 0l9.17651 311.659 9.31347 -311.659 -18.49 0zm24.8245 0l8.8341 311.659 9.34771 -311.659 -18.1818 0z" />
                </SvgIcon>
              </Button>
            </div>
          </div>
        </div>
        <Paper className={classes.root}>
          <EnhancedTableToolbar numSelected={selected.length} deleteButton={this.deleteUser} filtro={this.state.filtro} handleChange={this.handleChange} clear={this.clear} res={res} />
          <div className={classes.tableWrapper}>
            <Table className={classes.table} aria-labelledby="tableTitle" style={{ tableLayout: 'auto' }}>
              <EnhancedTableHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={this.handleSelectAllClick}
                onRequestSort={this.handleRequestSort}
                rowCount={data.length}
                res={res}
              />
              <TableBody>
                {data
                  .filter(item => {
                    return (
                      item.title.includes(this.state.filtro)
                    );
                  })
                  .sort(getSorting(order, orderBy))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map(n => {
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={n.id}
                        style={{ height: '3.6rem' }}
                      >
                        <TableCell></TableCell>
                        <TableCell component="th" scope="row" padding="none">{n.title}</TableCell>
                        <TableCell>{n.progress}</TableCell>
                        <TableCell>
                          <div>
                            <Button className='buttonMenu' disabled={n.progress < 100} onClick={event => this.downloadJob(n.id, ".kmz")} title={res.DOWNLOAD_KMZ}>
                              <MaterialIcon icon="download" className="iconMap highlightSVG" />
                            </Button>
                            <span style={n.progress < 100 ? this.estiloDonwOff : this.estiloDonwOn} >.KMZ</span>
                          </div>
                        </TableCell>
                        <TableCell>
                          <div>
                            <Button className='buttonMenu' disabled={n.progress < 100} onClick={event => this.downloadJob(n.id, ".json")} title={res.DOWNLOAD_JSON}>
                              <MaterialIcon icon="download" className="iconMap highlightSVG" />
                            </Button>
                            <span style={n.progress < 100 ? this.estiloDonwOff : this.estiloDonwOn} >.JSON</span>
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 49 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
          <TablePagination
            component="div"
            count={data.length}
            rowsPerPage={rowsPerPage}
            page={page}
            backIconButtonProps={{
              'aria-label': 'Previous Page',
            }}
            nextIconButtonProps={{
              'aria-label': 'Next Page',
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </Paper>
      </div >
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

const EnhancedTable1 = withStyles(styles)(EnhancedTable);

const Section = (props) => {
  const { link, res } = props;
  return (
    <div className="rowForm">
      <EnhancedTable1 link={link} res={res} />
    </div>)
}

export default Section;
